module.exports = __webpack_public_path__ + "img/startup-thumb.30e9abaa.png";